var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAgentNetworkIssue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Agent_Network_Issue"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Agent_Network_Issue",
    "data-name": "Agent Network Issue",
    clipPath: "url(#clip-Agent_Network_Issue)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "no-network_17489008",
    transform: "translate(-2 1.815)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M64.061,13.449a18.762,18.762,0,0,0,.882,5.742H12.34v48.6H5.179V18.459a6.443,6.443,0,0,1,6.452-6.452H64.126c-.043.473-.065.946-.065,1.441Z",
    transform: "translate(3.444 7.392)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M50.576,20.637V58.444H43.394V22.852a18.213,18.213,0,0,0,7.183-2.215Z",
    transform: "translate(44.843 16.741)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M102,42.483v2.753a8.614,8.614,0,0,1-8.6,8.6H10.6a8.613,8.613,0,0,1-8.6-8.6V42.483a2.157,2.157,0,0,1,2.151-2.151H42.86v4.022A2.06,2.06,0,0,0,44.9,46.419H59.1a2.047,2.047,0,0,0,2.043-2.064V40.333h38.71A2.157,2.157,0,0,1,102,42.483Z",
    transform: "translate(0 38.077)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1034",
    "data-name": "Group 1034",
    transform: "translate(30.656 35.881)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1030",
    "data-name": "Group 1030",
    transform: "translate(18.208 25.323)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M30.79,35.222a3.148,3.148,0,1,1-3.148-3.148,3.148,3.148,0,0,1,3.148,3.148Z",
    transform: "translate(-24.494 -32.074)",
    fill: "#e8eaf0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1031",
    "data-name": "Group 1031"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M55.711,30.837a26.336,26.336,0,0,0-37.2,0,1.613,1.613,0,0,1-2.281-2.281,29.56,29.56,0,0,1,41.764,0,1.613,1.613,0,0,1-2.281,2.281Z",
    transform: "translate(-15.755 -19.919)",
    fill: "#e8eaf0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1032",
    "data-name": "Group 1032",
    transform: "translate(5.689 8.043)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    d: "M47.064,32.344a18.283,18.283,0,0,0-25.825,0,1.613,1.613,0,0,1-2.281-2.281,21.512,21.512,0,0,1,30.387,0,1.613,1.613,0,0,1-2.281,2.281Z",
    transform: "translate(-18.486 -23.779)",
    fill: "#e8eaf0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1033",
    "data-name": "Group 1033",
    transform: "translate(11.377 16.084)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    d: "M38.417,33.85a10.23,10.23,0,0,0-14.448,0,1.613,1.613,0,0,1-2.281-2.281,13.457,13.457,0,0,1,19.009,0,1.613,1.613,0,1,1-2.281,2.281Z",
    transform: "translate(-21.216 -27.639)",
    fill: "#e8eaf0"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M50.625,5.185A15.645,15.645,0,1,0,66.26,20.84,15.639,15.639,0,0,0,50.625,5.185Zm6.107,19.484a1.585,1.585,0,0,1,0,2.28,1.621,1.621,0,0,1-2.279,0L50.625,23.12,46.8,26.948a1.6,1.6,0,0,1-2.28,0,1.585,1.585,0,0,1,0-2.28l3.828-3.828-3.828-3.828a1.62,1.62,0,1,1,2.28-2.3l3.828,3.828,3.828-3.828a1.619,1.619,0,0,1,2.279,2.3L52.9,20.84Z",
    transform: "translate(35.74)",
    fill: "#e8eaf0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentNetworkIssue);
export default __webpack_public_path__ + "static/media/agent-network-issue.2e189ae153bc6412b3c983041ba65b67.svg";
export { ForwardRef as ReactComponent };